import React from 'react';

export type GradingTab = 'exam' | 'assignments';

interface GradingTabsProps {
  activeTab: GradingTab;
  onTabChange: (tab: GradingTab) => void;
  examCount?: number;
  assignmentCount?: number;
}

export const GradingTabs: React.FC<GradingTabsProps> = ({
  activeTab,
  onTabChange,
  examCount = 0,
  assignmentCount = 0,
}) => {
  const tabs: Array<{ id: GradingTab; label: string; icon: string; count?: number }> = [
    { id: 'exam', label: 'Exam Grades', icon: '📝', count: examCount },
    { id: 'assignments', label: 'Assignment Grades', icon: '📚', count: assignmentCount },
  ];

  return (
    <div
      style={{
        display: 'flex',
        gap: 8,
        marginBottom: 24,
        borderBottom: '2px solid #e0e0e0',
      }}
    >
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        return (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            style={{
              padding: '12px 24px',
              background: isActive ? '#fff' : 'transparent',
              border: 'none',
              borderBottom: isActive ? '3px solid #007bff' : '3px solid transparent',
              color: isActive ? '#007bff' : '#666',
              fontWeight: isActive ? 700 : 600,
              fontSize: 15,
              cursor: 'pointer',
              transition: 'all 0.2s',
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              marginBottom: '-2px',
            }}
            onMouseEnter={(e) => {
              if (!isActive) {
                e.currentTarget.style.color = '#333';
                e.currentTarget.style.background = '#f8f9fa';
              }
            }}
            onMouseLeave={(e) => {
              if (!isActive) {
                e.currentTarget.style.color = '#666';
                e.currentTarget.style.background = 'transparent';
              }
            }}
          >
            <span style={{ fontSize: 20 }}>{tab.icon}</span>
            <span>{tab.label}</span>
            {tab.count !== undefined && tab.count > 0 && (
              <span
                style={{
                  background: isActive ? '#007bff' : '#ccc',
                  color: '#fff',
                  padding: '2px 8px',
                  borderRadius: 12,
                  fontSize: 12,
                  fontWeight: 700,
                }}
              >
                {tab.count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
};
